import factory from './icon';
import Svg from './glyphs/shopping_bag.svg';

export default factory(Svg);
